




















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  filters: {
    headline(headline: any): any {
      if (typeof(headline) === 'string') {
        // tslint:disable-next-line:max-line-length
        const regex = /^(.*)issued\s+(january|february|march|april|may|june|july|august|september|october|november|december).*$/gi;
        return headline.replace(regex, '$1');
      }
      return headline;
    },
  },
})
export default class Hit extends Vue {
  @Prop({ required: true })
  private hit?: any;

  private severityVariants: Map<string, string> = new Map<string, string>()
    .set('EXTREME', 'danger')
    .set('SEVERE', 'warning')
    .set('MODERATE', 'info')
    .set('MINOR', 'success');

  private certaintyVariants: Map<string, string> = new Map<string, string>()
    .set('OBSERVED', 'danger')
    .set('LIKELY', 'warning')
    .set('POSSIBLE', 'info')
    .set('UNLIKELY', 'success');

  private urgencyVariants: Map<string, string> = new Map<string, string>()
    .set('IMMEDIATE', 'danger')
    .set('EXPECTED', 'warning')
    .set('FUTURE', 'info')
    .set('PAST', 'success');

  private responseTypeVariants: Map<string, string> = new Map<string, string>()
    .set('SHELTER', 'danger')
    .set('EVACUATE', 'danger')
    .set('PREPARE', 'warning')
    .set('EXECUTE', 'warning')
    .set('AVOID', 'warning')
    .set('MONITOR', 'info')
    .set('ASSESS', 'info')
    .set('ALL_CLEAR', 'success')
    .set('NONE', 'success');


  private get displayAreas(): string[] {
    if (this.hit && this.hit.info && this.hit.info.areas) {
      let areas = this.hit.info.areas.map((area: any) => area.description).sort();

      // Handle nws
      if (this.hit.alert.system === 'nws') {
        areas = areas[0].split(';').sort();
      }

      // Only show 4
      if (areas.length > 4) {
        const rem: number = areas.length - 3;
        areas = areas.slice(0, 4);
        areas[3] = `+ ${rem} more`;
      }

      return areas;
    }

    return [];
  }
}
